<form class="form-group" #customerForm="ngForm">
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>First Name</label>
      <input
        type="text"
        class="form-control"
        name="FirstName"
        ngModel
        required
        placeholder="First Name"
      />
    </div>
    <div class="col-sm-6">
      <label>Last Name</label>
      <input
        type="text"
        class="form-control"
        name="LastName"
        ngModel
        required
        placeholder="Last Name"
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>Email Address</label>
      <input
        type="email"
        class="form-control"
        name="EmailAddress"
        ngModel
        placeholder="Email Address"
        required
        email
      />
    </div>
    <div class="col-sm-6">
      <label>Department</label>
      <input
        type="text"
        class="form-control"
        name="Department"
        ngModel
        placeholder="Department"
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>Phone Type</label>
      <select class="form-control" name="PhoneType" ngModel>
        <option value="1">Mobile</option>
        <option value="2">Home</option>
        <option value="3">Office</option>
      </select>
    </div>
    <div class="col-sm-6">
      <label>Phone Number</label>
      <input
        type="text"
        class="form-control"
        name="PhoneNumber"
        ngModel
        placeholder="Phone Number"
        required
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>Address Type</label>

      <select class="form-control" name="AddressType" ngModel>
        <option value="1">Home</option>
        <option value="2">Office</option>
        <option value="3">Shipping</option>
        <option value="4">Billing</option>
      </select>
    </div>
    <div class="col-sm-6">
      <label>Street Address</label>
      <input
        type="text"
        class="form-control"
        name="StreetAddress"
        ngModel
        required
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>Address 2</label>
      <input
        type="text"
        class="form-control"
        name="Address2"
        ngModel
        placeholder="Address 2"
      />
    </div>
    <div class="col-sm-6">
      <label>City</label>
      <input
        type="text"
        class="form-control"
        name="City"
        ngModel
        placeholder="City"
        required
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>State</label>
      <select
        class="form-control"
        name="State"
        ngModel
        [disabled]="!isUSA"
        required>
        <option disabled selected>State</option>
        <option *ngFor="let state of usStates" value="{{ state.abbreviation }}">
          {{ state.abbreviation }}
        </option>
      </select>
    </div>
    <div class="col-sm-6">
      <label>Country</label>
      <select
        class="form-control"
        name="CountryId"
        [ngModel]="230"
        (change)="countryChanged($event)"
        required>
        <option hidden>-Select a country-</option>
        <option *ngFor="let country of countries" value="{{ country.Id }}">
          {{ country.CountryName }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <label>ZIP Code</label>
      <input
        type="text"
        class="form-control"
        name="ZipCode"
        ngModel
        placeholder="ZIP Code"
        required
      />
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-6">
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          name="IsDefault"
          id="IsDefault"
          name="IsMainContact"
          [ngModel]="true"
        />
        <label class="custom-control-label" for="IsDefault"
          >Default Contact Person</label
        >
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <button
      (click)="save()"
      class="btn btn-outline ml-auto"
      [disabled]="
        !customerForm.valid ||
        !customerForm.value.FirstName ||
        !customerForm.value.LastName ||
        !customerForm.value.EmailAddress
      "
    >
      <i class="fas fa-plus"></i> Add another contact
    </button>
  </div>
  <div>
    <h6>Contact Persons</h6>
    <table class="table table-bordered" width="100%" style="padding: 10px">
      <thead class="thead-light" style="padding: 10px">
        <tr>
          <th width="40%">Full name</th>
          <th width="40%">Email</th>
          <th width="10%">Default</th>
          <th width="10%"></th>
        </tr>
      </thead>
      <tbody style="padding: 10px">
        <tr *ngIf="!contactPersons || !contactPersons.length">
          <td colspan="5" class="text-center">No contact number yet.</td>
        </tr>
        <tr
          style="padding: 10px"
          *ngFor="let contact of contactPersons; let i = index"
        >
          <td width="40%">{{ contact.FirstName + " " + contact.LastName }}</td>
          <td width="40%">{{ contact.EmailAddress }}</td>
          <td align="center" width="10%" style="vertical-align: center">
            <i class="fas fa-check-circle" *ngIf="contact.IsMainContact"></i>
          </td>
          <td align="center" width="10%">
            <button
              type="button"
              title="Remove address"
              class="btn btn-sml btn-secondary"
              (click)="removeContactPerson(i)"
            >
              <small><i class="fas fa-minus-circle"></i></small>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
